import { useLocation } from 'react-router-dom';

import { useAppSelector } from 'store';
import { selectUser } from 'store/user';
import { isHipaaLink } from 'config/productProfile';

export function useIsGuestCall(): boolean {
  const user = useAppSelector(selectUser);
  const location = useLocation();

  // Guest call = public link waiting room (not HIPAA, not signed in, not home)
  return !isHipaaLink && !user && location.pathname !== '/';
}
